import ScrollbarsCustom from 'react-scrollbars-custom'
import styled from 'styled-components'

export const StyledScrollbars = styled(ScrollbarsCustom)`
    .ScrollbarsCustom-Track.ScrollbarsCustom-TrackY {
        right: 4px !important;
        width: 6px !important;

        .ScrollbarsCustom-Thumb.ScrollbarsCustom-ThumbY {
            background: var(--gray-600) !important;
        }
    }

    .ScrollbarsCustom-Track.ScrollbarsCustom-TrackX {
        height: 6px !important;

        .ScrollbarsCustom-Thumb.ScrollbarsCustom-ThumbX {
            background: var(--gray-600) !important;
        }
    }
`
